module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-17.3a6e5afd.JPG";